import { InjectionToken } from '@angular/core';



export const RECAPTCHA_V3_SITE_KEY = new InjectionToken<string>('ReCaptchaV3SiteKeyToken');

export type ReCaptchaV3ConfigFactory = () => string;
